var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"systemSettlementCurrency"},[_c('span',[_vm._v("结算币种：")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.currency))])])}
var staticRenderFns = []

export { render, staticRenderFns }